import React from "react";
import "./about.css";
import aboutimg from "../../assets/about.jpg";
import funimg from "../../assets/fun.jpg";

import ScrollReveal from "../ScrollReveal";
import Scrolllefteffect from "../Scrolllefteffect";

const About = () => {
  return (
    <div id="about">
      <div
        className="about__row-container"
        style={{ display: "flex", flexDirection: "row" }}
      >
        <div className="about__row-img">
          <img src={aboutimg} alt="about-img" />
        </div>
        <div className="about__row-text">
          <ScrollReveal>
            <h1>
              Creative <br /> & fresh
            </h1>
          </ScrollReveal>

          <Scrolllefteffect>
            <h3>Our digital agency</h3>
          </Scrolllefteffect>

          <p className="about_text">
            Focus infographic venture business model canvas gamification
            ecosystem. Business plan gamification user experience low hanging
            fruit twitter. Metrics research & development market paradigm shift
            growth hacking disruptive user experience iPad social media angel
            investor alpha. Social proof lean startup alpha scrum project
            non-disclosure agreement.
          </p>
          <button type="button">
            <a href="#portfolio">
              {" "}
              <div className="about__btn">View Portfolio</div>{" "}
            </a>
          </button>
        </div>
      </div>

      <div
        className="about__row-container about2"
        style={{ display: "flex", flexDirection: "row" }}
      >
        <div className="about2__row-text">
          <ScrollReveal>
            <h1>
              Hip <br /> & Funky
            </h1>
          </ScrollReveal>

          <Scrolllefteffect>
            <h3>We try new things</h3>
          </Scrolllefteffect>

          <p className="about_text">
            Focus infographic venture business model canvas gamification
            ecosystem. Business plan gamification user experience low hanging
            fruit twitter. Metrics research & development market paradigm shift
            growth hacking disruptive user experience iPad social media angel
            investor alpha. Social proof lean startup alpha scrum project
            non-disclosure agreement.
          </p>
          <button type="button">
            <a href="#service">
              {" "}
              <div className="about__btn">Our Services</div>
            </a>
          </button>
        </div>

        <div className="about2__row-img">
          <img src={funimg} alt="about-img" />
        </div>
      </div>
    </div>
  );
};

export default About;
